import React from 'react';
import { FaTasks, FaBookReader, FaUsers } from 'react-icons/fa';
import { PiArticleMediumFill } from 'react-icons/pi';
import { MdOutlineEditNote, MdPayment } from 'react-icons/md';
import { TbBrandBlogger } from 'react-icons/tb';

import EssayPromptManagement from './EssayPromptManagement';
import EssayManagement from './EssayManagement';
import RelayPromptManagement from './RelayPromptManagement';
import RelayStoryManagement from './RelayStoryManagement';
import Payments from './Payments';
import UserManagement from './UserManagement';
import BlogManagement from './BlogManagement';

export const AdminTabs = [
  {
    key: 'blogs',
    name: 'Blogs',
    link: 'blogs',
    icon: <TbBrandBlogger />,
    content: <BlogManagement />,
  },
  {
    key: 'essay-prompt',
    name: 'Essay Prompt',
    link: 'essay-prompt',
    icon: <FaTasks />,
    content: <EssayPromptManagement />,
  },
  {
    key: 'essay',
    name: 'Essay',
    link: 'essay',
    icon: <PiArticleMediumFill />,
    content: <EssayManagement />,
  },
  {
    key: 'relay-prompt',
    name: 'Relay Prompt',
    link: 'relay-prompt',
    icon: <MdOutlineEditNote />,
    content: <RelayPromptManagement />,
  },
  {
    key: 'story',
    name: 'Relay Story',
    link: 'story',
    icon: <FaBookReader />,
    content: <RelayStoryManagement />,
  },
  {
    key: 'payments',
    name: 'Payments',
    link: 'payments',
    icon: <MdPayment />,
    content: <Payments />,
  },
  {
    key: 'users',
    name: 'Users',
    link: 'users',
    icon: <FaUsers />,
    content: <UserManagement />,
  },
];
